import { GridCellProps, GridItemChangeEvent } from '@progress/kendo-react-grid';
import React from 'react';
import { DEFAULT_NUMERIC_TEXTBOX_STEP, EMPTY_VALUE } from '../../../config/consts';
import { NumericTextBox, NumericTextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { useInternationalization } from '@progress/kendo-react-intl';
import { GearGridCell } from './GearGridCell';
import { GearFieldType } from '../../../global/enums/GearFieldType';
import { IntlHelper } from '../../../helpers/IntlHelper';

interface EditableNumericTextBoxCellProps extends GridCellProps {
  onItemChange?: (event: GridItemChangeEvent) => void;
  inEdit?: boolean;
  fieldType: GearFieldType;
  step?: number;
}

export const EditableNumericTextBoxCell: React.FC<EditableNumericTextBoxCellProps> = props => {
  const field = props.field || EMPTY_VALUE;
  const value = props.dataItem[field] as number;
  const intl = useInternationalization();

  const handleChange = (event: NumericTextBoxChangeEvent): void => {
    if (!props.onItemChange) {
      return;
    }

    const newEvent: any = {
      ...event,
      dataItem: props.dataItem,
      field
    };
    props.onItemChange(newEvent);
  };

  let formattedValue = null;
  if (isNaN(value)) {
    formattedValue = props.inEdit === false ? '' : '<NaN>';
  } else if (props.fieldType === 'numeric') {
    formattedValue = IntlHelper.formatNumber(intl, value, 'n2');
  } else {
    formattedValue = value?.toString();
  }

  return (
    <GearGridCell {...props} customClassName="editableNumericTextBoxCell" title={formattedValue}>
      {props.inEdit === false ? (
        <>{formattedValue}</>
      ) : (
        <NumericTextBox
          step={props.step ?? DEFAULT_NUMERIC_TEXTBOX_STEP}
          min={0}
          max={1000}
          format="#"
          value={value}
          onChange={handleChange}
        />
      )}
    </GearGridCell>
  );
};
